<template>
  <div class="content">
    <div id="map_cn" class="map_cn"></div>
    <div class="bgc map_but">
      {{ mapBut }}
    </div>
  </div>
</template>
 
<script>
import "../utils/hunan.js"; //这一步必须引入
import bus from "../utils/bus.js";

export default {
  props: {
    mapBut: {},
  },

  data() {
    return {
      mapId: "",
      myChart: null,
      //地图中的数据
      dataList: [],
      city_id: 0,
      //指定图表的配置项和数据
      option: {
        // 注释部分是图的标题，按需要进行修改
        // title: {
        //   text: '各区域设备分布情况',
        //   subtext: '',
        //   padding: [15, 15],
        //   textStyle: {
        //     fontFamily: '宋体',
        //     fontSize: 16,
        //     fontWeight: 'normal',
        //     color: '#55aaff'
        //   }
        // },
        tooltip: {
          show: true,
          //触发类型：数据项图形触发

          position: ["5%", "60%"],
          trigger: "item",
          triggerOn: "click",
          padding: 10,
          extraCssText: "z-index:3",
          borderWidth: 1,
          borderColor: "#409eff",
          backgroundColor: "rgba(255,255,255)",
          textStyle: {
            color: "#000000",
            fontSize: 12,
          },
          formatter: function (params) {
            var res = "";
            res += "<div>" + params.name + " </div>";
            res += "<div>" + "县：" + ":" + params.data.aData + "个" + "</div>";
            res +=
              "<div>" +
              "乡/镇/社区：" +
              ":" +
              params.data.bData +
              "个" +
              "</div>";
            res += "<div>" + "村：" + ":" + params.data.cData + "个" + "</div>";
            return res;
          },
        },
        series: [
          {
            map: "湖南",
            type: "map",
            aspectScale: 0.9,
            silent: true,
            // roam: false,
            data: [{ name: "长沙市", selected: true, value: 100 }],
            itemStyle: {
              normal: {
                // 图形的描边颜色
                borderColor: "#000",
                // 描边线宽。
                borderWidth: 1,
                // 柱条的描边类型。
                borderType: "solid",
                // 图形的颜色 #233F53
                areaColor: "rgba(255, 255, 255)",
                // 图形阴影的模糊大小。
                shadowBlur: 5,
                // 阴影色 #233F53
                shadowColor: "#rgba(172, 172, 172, 0)",
                // X轴阴影
                shadowOffsetX: 5,
                // Y轴阴影
                shadowOffsetY: 5,
                label: {
                  // 显示省份下面市、州的名称
                  show: false,
                  textStyle: {
                    color: "#fff",
                    fontSize: 10,
                  },
                },
              },
              // 鼠标放上去后，样式改变
              emphasis: {
                // 图形的描边颜色
                borderColor: "#rgba(172, 172, 172)",
                borderWidth: "1",
                // 阴影色
                areaColor: "rgb(30, 116, 255)",
                label: {
                  show: true,
                  textStyle: {
                    color: "rgba(255, 255, 255)",
                    fontSize: 10,
                  },
                },
              },
              effect: {
                show: true,
                shadowBlur: 10,
                loop: true,
              },
            },
            // select: { // 地图选中区域样式
            //   label: { // 选中区域的label(文字)样式
            //     color: 'rgba(255, 255, 255, 0)'
            //   },
            //   itemStyle: {// 选中区域的默认样式
            //     areaColor: 'rgba(255, 255, 255, 0)'
            //   },
            // },
            layoutCenter: ["65%", "50%", "0", "0"], // 距离左右，上下距离的百分比
            layoutSize: "100%", // map百分比大小
          },
        ],
      },
    };
  },
  mounted() {
    this.getShenList();
  },
  methods: {
    getShenList() {
      var date = JSON.parse(localStorage.getItem("date"));
      this.dataList = date.map((element) => {
        var a = element.slist.map(function (elem) {
          return elem.region_burg;
        });
        // console.log(a.join("、"));
        a = a.join("、");
        var cData = 0;
        var bData = 0;
        var aData = 0;
        for (let i = 0; i < a.length; i++) {
          if (a[i] === "村") {
            cData++;
          }
          if (a[i] === "乡" || a[i] === "镇" || a[i] === "社区") {
            bData++;
          }
          if (a[i] === "县" || a[i] === "市") {
            aData++;
          }
        }
        return {
          name: element.region,
          aData: aData,
          bData: bData,
          cData: cData,
        };
      });
      console.log(this.dataList);
      this.setEchartOption();
      this.$nextTick(() => {
        this.draw_map();
      });
    },

    //定义方法 draw_map 绘制中国地图
    draw_map() {
      this.myChart = this.$echarts.init(document.getElementById("map_cn"));

      this.myChart.off("click");

      bus.$on("mapBus", (mapData) => {
        console.log(mapData); //componentA参数

        var date = JSON.parse(localStorage.getItem("date"));
        date.forEach((item, index) => {
          if (item.region == mapData.region) {
            this.city_id = index;
          }
        });

        this.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
        });
        this.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: this.city_id,
        });
        this.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: this.city_id,
        });
      });

      //显示地图
      this.myChart.setOption(this.option);

      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },

    //修改echart配制
    setEchartOption() {
      this.option.series[0].data = this.dataList;
    },
  },
  created() {
    this.setEchartOption();
  },
};
</script>
 
<style scoped lang="less">
.content {
  position: relative;
  margin: 0 0 0 -3%;
  // width: 43vw;
  height: 40vh;

  .map_cn {
    width: 100%;
    height: 98%;
    padding-top: 1%;
  }
  .map_but {
    position: absolute;
    right: 8%;
    bottom: 0;
    color: #333;
    font-weight: 900;
    border-radius: 5px;
    cursor: pointer;
    z-index: 10;
  }
  .map_but:hover {
    color: rgb(30, 116, 255);
  }
}
</style>